import { TitleContainer } from "../assets/styles/generalStyles"
import {
    LocationH1,
    LocationP,
    LocationContainer,
    LocationTextField,
} from '../assets/styles/locationsStyles';
import { Location, LocationInfo } from '../assets/ts/customTypes';
import { TheSun } from "../lib/components/TheSun";
import Autocomplete from '@mui/material/Autocomplete';
import coordinates from '../assets/json/coordinates.json';

const locations = coordinates as Location;

export function PageLocations({
    uvIndex = 0,
    setUvIndex,
    setCurrentLocation,
}: {
    uvIndex?: number;
    setUvIndex: (uvIndex: number) => void;
    setCurrentLocation: (location: Location) => void;
}) {
    return (
        <>
            <TheSun isInText={false} bottom='25%' />
            <LocationContainer>
                <TitleContainer>
                    <LocationH1>ORTSSUCHE</LocationH1>
                </TitleContainer>
                <LocationP>
                    Geben Sie den Namen der Gemeinde ein, in der Sie sich gerade befinden, um den aktuellen
                    UV-Tageshöchstwert abzurufen:
                </LocationP>
                <Autocomplete
                    classes={{paper: 'locationPaper'}}
                    options={Object.keys(locations)}
                    getOptionLabel={(option) => option}
                    onChange={(event, newValue) => {
                        if (newValue && typeof newValue === 'string') {
                            const currentLocation = locations[newValue];
                            const newLoc: Location = { [newValue]: currentLocation };
                            handleSelection(newLoc);
                        }
                    }}
                    renderInput={(params) => (
                        <LocationTextField {...params} label="Gemeinde" variant="outlined" />
                    )}
                />
            </LocationContainer>
        </>
    );

    function handleSelection(location: Location) {
        if (!location) {
            console.error(`Invalid location ${location}`);
            return;
        }
        updateUvIndex(location).then(() => { setCurrentLocation(location); });
    }
    function updateUvIndex(newLocation: Location) {
        const locationName = Object.keys(newLocation)[0];
        const info: LocationInfo = Object.values(newLocation)[0];
        return (async () => {
            const indexRes = await fetch('/get-uv-index.php', {
                method: 'POST',
                credentials: 'same-origin',
                body: JSON.stringify({ lat: info.lat, long: info.long, name: locationName }),
            });
            if (indexRes.ok) {
                const indexJson: { ok: boolean; index: number; name: string } = await indexRes.json();
                if (indexJson.ok) {
                    setUvIndex(indexJson.index);
                }
            }
        })();
    }
}